import React from 'react';
import { Plus, Search } from 'lucide-react';

// Style constants
const COLORS = {
  NEUTRAL_BG: '#F8F9FA',
  NEUTRAL_WHITE: '#FFFFFF',
  NEUTRAL_TEXT: '#1A1A1A',
  ACCENT_GRAY: '#6B7280',
  PRIMARY_BROWN: '#8B4513'
};

const FONTS = {
  heading: { fontFamily: 'Inter, system-ui, sans-serif' },
  body: { fontFamily: 'Inter, system-ui, sans-serif' }
};

export function EmptyState({ 
  hasFilters, 
  hasSearch, 
  onAddProduct, 
  onClearFilters,
  className = ''
}) {
  const getTitle = () => {
    if (hasSearch) return 'No products found';
    if (hasFilters) return 'No products match your filters';
    return 'No products yet';
  };

  const getDescription = () => {
    if (hasSearch) {
      return 'Try adjusting your search terms or browse all products';
    }
    if (hasFilters) {
      return 'Try adjusting your filters or clear them to see all products';
    }
    return 'Start by adding your first product to your store';
  };

  const getActionButton = () => {
    if (hasSearch || hasFilters) {
      return (
        <button
          onClick={onClearFilters}
          style={{
            background: COLORS.NEUTRAL_BG,
            color: COLORS.NEUTRAL_TEXT,
            border: '1px solid #E0E0E0',
            borderRadius: 8,
            padding: '8px 16px',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            ...FONTS.body
          }}
        >
          <Search size={16} />
          Clear Filters
        </button>
      );
    }

    return (
      <button
        onClick={onAddProduct}
        style={{
          background: COLORS.PRIMARY_BROWN,
          color: COLORS.NEUTRAL_WHITE,
          border: 'none',
          borderRadius: 8,
          padding: '8px 16px',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          ...FONTS.body
        }}
      >
        <Plus size={16} />
        Add Your First Product
      </button>
    );
  };

  return (
    <div
      className={`empty-state ${className}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        textAlign: 'center',
        padding: '32px 16px'
      }}
    >
      {/* Icon */}
      <div style={{
        width: 64,
        height: 64,
        borderRadius: '50%',
        background: COLORS.NEUTRAL_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 16
      }}>
        {hasSearch || hasFilters ? (
          <Search size={32} style={{ color: COLORS.ACCENT_GRAY }} />
        ) : (
          <Plus size={32} style={{ color: COLORS.ACCENT_GRAY }} />
        )}
      </div>

      {/* Title */}
      <h3 style={{
        fontSize: 18,
        fontWeight: 600,
        color: COLORS.NEUTRAL_TEXT,
        margin: '0 0 8px 0',
        ...FONTS.heading
      }}>
        {getTitle()}
      </h3>

      {/* Description */}
      <p style={{
        fontSize: 14,
        color: COLORS.ACCENT_GRAY,
        margin: '0 0 24px 0',
        maxWidth: 300,
        lineHeight: 1.4,
        ...FONTS.body
      }}>
        {getDescription()}
      </p>

      {/* Action Button */}
      {getActionButton()}
    </div>
  );
}
